/* Behaviour for the zy-* sections (ported from the reference funnel's inline scripts). */
(function () {
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function store(k, v) { try { if (v === undefined) return parseInt(sessionStorage.getItem(k), 10); sessionStorage.setItem(k, String(v)); } catch (e) {} }

  function carousels(root) {
    root.querySelectorAll('[data-car]').forEach(function (c) {
      if (c.dataset.zyReady) return; c.dataset.zyReady = '1';
      var tr = c.querySelector('[data-track]'), dots = c.querySelector('[data-dots]'), pv = c.querySelector('[data-prev]'), nx = c.querySelector('[data-next]');
      if (!tr) return;
      function pages() { var it = tr.children[0]; if (!it) return 1; var per = Math.max(1, Math.round(tr.clientWidth / (it.offsetWidth + 24))); return Math.max(1, Math.ceil(tr.children.length / per)); }
      function upd() {
        var n = pages(), max = tr.scrollWidth - tr.clientWidth, p = max > 0 ? Math.round(tr.scrollLeft / max * (n - 1)) : 0;
        if (dots) [].forEach.call(dots.children, function (d, k) { d.classList.toggle('on', k === p); });
        if (pv) pv.disabled = tr.scrollLeft < 5; if (nx) nx.disabled = tr.scrollLeft > max - 5;
      }
      function build() { if (dots) dots.innerHTML = new Array(pages() + 1).join('<i></i>'); upd(); }
      if (pv) pv.onclick = function () { tr.scrollBy({ left: -tr.clientWidth, behavior: 'smooth' }); };
      if (nx) nx.onclick = function () { tr.scrollBy({ left: tr.clientWidth, behavior: 'smooth' }); };
      tr.addEventListener('scroll', upd, { passive: true }); window.addEventListener('resize', build); build();
    });
    root.querySelectorAll('.bcard').forEach(function (c) { if (!c.onclick) c.onclick = function () { c.classList.toggle('on'); }; });
  }

  function sold(root) {
    root.querySelectorAll('[data-zy-sold]').forEach(function (el) {
      if (el.dataset.zyReady) return; el.dataset.zyReady = '1';
      var pct = parseInt(el.getAttribute('data-zy-sold'), 10) || 87, bar = el.querySelector('.bar i'), out = el.querySelector('[data-pct]'), done = false;
      function fill() { if (done) return; done = true; bar.style.width = pct + '%'; var t0 = performance.now(); (function s(t) { var k = Math.min(1, (t - t0) / 1600), e = 1 - Math.pow(1 - k, 3); out.textContent = Math.round(pct * e); if (k < 1) requestAnimationFrame(s); })(t0); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en, o) { if (en[0].isIntersecting) { fill(); o.disconnect(); } }, { threshold: 0.6 }).observe(el); else fill();
    });
  }

  function timers(root) {
    root.querySelectorAll('[data-zy-sale]').forEach(function (el) {
      if (el.dataset.zyReady) return; el.dataset.zyReady = '1';
      var dur = (parseInt(el.getAttribute('data-zy-sale'), 10) || 10) * 60000, end = store('zy_sale_end');
      if (!end || end < Date.now()) { end = Date.now() + dur; store('zy_sale_end', end); }
      function tick() { var s = Math.max(0, Math.floor((end - Date.now()) / 1000)); if (s === 0) { end = Date.now() + dur; store('zy_sale_end', end); } el.textContent = pad(Math.floor(s / 60)) + ':' + pad(s % 60); }
      tick(); setInterval(tick, 1000);
    });
    root.querySelectorAll('[data-zy-bar]').forEach(function (el) {
      if (el.dataset.zyReady) return; el.dataset.zyReady = '1';
      var dur = (parseInt(el.getAttribute('data-zy-bar'), 10) || 2) * 3600000, end = store('zy_bar_end');
      if (!end || end <= Date.now()) { end = Date.now() + dur; store('zy_bar_end', end); }
      var h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]'), s = el.querySelector('[data-s]');
      function tick() { var d = Math.max(0, end - Date.now()); if (d <= 0) { end = Date.now() + dur; store('zy_bar_end', end); d = dur; } var t = Math.floor(d / 1000); h.textContent = pad(Math.floor(t / 3600)); m.textContent = pad(Math.floor((t % 3600) / 60)); s.textContent = pad(t % 60); }
      tick(); setInterval(tick, 1000);
    });
  }

  function ship(root) {
    root.querySelectorAll('[data-zy-ship]').forEach(function (el) {
      if (el.dataset.zyReady) return; el.dataset.zyReady = '1';
      // sit directly above the add-to-cart button, below the bundle widget (as on the reference page)
      var form = el.closest('.product__info-container') || document;
      var btns = form.querySelector('.product-form__buttons');
      if (btns && btns.parentNode) btns.parentNode.insertBefore(el, btns);
      var days = parseInt(el.getAttribute('data-days'), 10) || 5, d = new Date(), added = 0;
      while (added < days) { d.setDate(d.getDate() + 1); var w = d.getDay(); if (w !== 0 && w !== 6) added++; }
      var dateEl = el.querySelector('[data-zy-shipdate]');
      var loc = (dateEl && dateEl.getAttribute('data-locale')) === 'en' ? 'en-US' : 'es-MX';
      if (dateEl) dateEl.textContent = d.toLocaleDateString(loc, { weekday: 'short', month: 'short', day: 'numeric' });
      var t = el.querySelector('[data-zy-shiptimer]'), secs = 300;
      (function tick() { if (!t) return; t.textContent = pad(Math.floor(secs / 60)) + ':' + pad(secs % 60); if (secs > 0) { secs--; setTimeout(tick, 1000); } })();
    });
  }

  function init(root) { root = root || document; carousels(root); sold(root); timers(root); ship(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  window.addEventListener('load', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* LP gallery (from the v2 dz.js) */
(function () {
  function initGallery(root) {
    if (root.dataset.dzReady) return;
    root.dataset.dzReady = '1';
    var main = root.querySelector('.dzg-main');
    var thumbs = root.querySelectorAll('.dzg-thumbs button');
    function go(i) { main.scrollTo({ left: i * main.clientWidth, behavior: 'smooth' }); }
    thumbs.forEach(function (b, i) { b.addEventListener('click', function () { go(i); }); });
    var prev = root.querySelector('.arr.l'), next = root.querySelector('.arr.r');
    function cur() { return Math.round(main.scrollLeft / main.clientWidth); }
    var last = 0;
    if (prev) prev.addEventListener('click', function () { go(Math.max(0, cur() - 1)); });
    if (next) next.addEventListener('click', function () { go(Math.min(thumbs.length - 1, cur() + 1)); });
    main.addEventListener('scroll', function () {
      var i = cur();
      thumbs.forEach(function (b, j) { b.classList.toggle('on', i === j); });
      var t = thumbs[i], row = t && t.parentNode;
      if (t && i !== last) { last = i; row.scrollTo({ left: t.offsetLeft - row.offsetLeft - (row.clientWidth - t.offsetWidth) / 2, behavior: 'smooth' }); }
    }, { passive: true });
  }

  function init(s){(s||document).querySelectorAll('[data-dz-gallery]').forEach(initGallery);}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();

/* LP extras: price row follows the selected bundle, dark review slider, ship row pinned above the button */
(function () {
  function num(t) { var m = (t || '').replace(/,/g, '').match(/[\d.]+/); return m ? parseFloat(m[0]) : NaN; }
  function setT(e, v) { if (e && e.textContent !== v) e.textContent = v; }
  function setH(e, h) { if (e && e.hidden !== h) e.hidden = h; }
  function syncPrice() {
    var row = document.querySelector('[data-zy-pr]'), sel = document.querySelector('.kaching-bundles__bar--selected');
    if (!row || !sel) return;
    var pe = sel.querySelector('.kaching-bundles__bar-price'), fe = sel.querySelector('.kaching-bundles__bar-full-price');
    var now = pe && pe.textContent.trim(), was = fe && fe.textContent.trim();
    if (!now) return;
    var cur = (now.match(/^[^\d]*/) || [''])[0] || '$';
    setT(row.querySelector('.zy-pr-now'), now);
    var w = row.querySelector('.zy-pr-was'), bd = row.querySelector('.zy-pr-badge'), s = num(was) - num(now);
    if (was && s > 0) { setT(w, was); setH(w, false); setH(bd, false); setT(row.querySelector('.zy-pr-save'), cur + s.toFixed(2).replace(/\.00$/, '')); }
    else { setH(w, true); setH(bd, true); }
  }
  function slider() {
    document.querySelectorAll('[data-zy-rs]').forEach(function (box) {
      if (box.dataset.ready) return; box.dataset.ready = '1';
      var track = box.querySelector('.zy-rs-track'), segs = box.querySelectorAll('.zy-rs-line button'), n = track.children.length, paused = false;
      function current() { return Math.min(n - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth))); }
      function paint() { var k = current(); [].forEach.call(segs, function (b, j) { b.classList.toggle('on', j === k); }); }
      function go(k) { track.scrollTo({ left: k * track.clientWidth, behavior: 'smooth' }); }
      track.addEventListener('scroll', paint, { passive: true });
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (ev) { track.addEventListener(ev, function () { paused = true; }, { passive: true }); });
      [].forEach.call(segs, function (b, j) { b.addEventListener('click', function () { paused = true; go(j); }); });
      if (n > 1) setInterval(function () { if (!paused && !document.hidden) go((current() + 1) % n); }, 5000);
    });
  }
  function pinShip() {
    var el = document.querySelector('[data-zy-ship]'); if (!el) return;
    var root = el.closest('.product__info-container') || document, btns = root.querySelector('.product-form__buttons');
    if (btns && btns.previousElementSibling !== el) btns.parentNode.insertBefore(el, btns);
  }
  function init() {
    slider(); pinShip(); syncPrice();
    var info = document.querySelector('.product__info-container');
    if (info && !info.dataset.zyObs) {
      info.dataset.zyObs = '1';
      new MutationObserver(function () { pinShip(); syncPrice(); }).observe(info, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', init);
  document.addEventListener('shopify:section:load', init);
})();
